class TranslationHelper {
    static setAllTranslationsVisible(visible, translations) {
        for (let i = 0; i < translations.length; i++) {
            translations[i].visible = visible;
            if (translations[i].children) {
                this.setAllTranslationsVisible(visible, translations[i].children);
            }
        }

        return translations
    }

    static setTranslationsVisibleBySearchString(searchString, searchPath, translations) {
        let translation;
        for (let i = 0; i < searchPath.length; i++) {
            translation = searchPath[i];
            if(translation.type === 'translation') {
                if (translation.fullKey.indexOf(searchString) !== -1) {
                    translation.visible = true;
                    this.setTranslationTreeVisibleByFullKey(translation.fullKey, translations, translations);
                }
                else {
                    if(translation.strings instanceof Object) {
                        Object.keys(translation.strings).map((key) => {
                                if (translation.strings[key] && translation.strings[key].value.toLowerCase().indexOf(searchString.toLowerCase()) !== -1) {
                                    translation.visible = true;
                                    this.setTranslationTreeVisibleByFullKey(translation.fullKey, translations, translations);
                                }
                            }
                        )
                    }
                }
            }
            if (translation.children) {
                TranslationHelper.setTranslationsVisibleBySearchString(searchString, translation.children, translations);
            }
        }
        return translations;
    }

    static setTranslationTreeVisibleByFullKey(fullKey, searchPath, translations) {
        let translation;
        if (searchPath) {
            for (let j = 0; j < searchPath.length; j++) {
                translation = searchPath[j];
                if (fullKey.indexOf(translation.fullKey) === 0 || translation.fullKey.indexOf(fullKey) === 0) {
                    translation.visible = true;
                }
                if (translation.children) {
                    this.setTranslationTreeVisibleByFullKey(fullKey, translation.children, translations);
                }
            }
        }
    }
}

export default TranslationHelper;